module.exports = __webpack_public_path__ + "img/Sport-Climbing.4d399d54.png";